import { useState } from 'react'
import { Field, Lookup, Panel } from '../design/index.js'
import { navigate, paths } from '../app/router.js'
import { ProjectDrivePage } from './ProjectDrivePage.js'

/**
 * The Project Drive route (docs/05 §2).
 *
 * Entering it asks which project, exactly as the source system does, because
 * the drive has no meaning without one — every file in it belongs to a job.
 * The choice is kept in the URL so the page can be linked to and bookmarked.
 */
export const DrivePage = ({
  companyId, query,
}: {
  companyId: string
  query: Readonly<Record<string, string>>
}) => {
  const projectId = query['project'] ?? ''
  const [label, setLabel] = useState<string>('')

  return (
    <div className="page">
      <h1 className="page-title">Project Drive</h1>
      <p className="page-subtitle">
        Everything about one job that is not a document: its files, who is on it, what has been
        said about it, and where it stands against its own dates.
      </p>

      <Panel title={projectId ? label || 'Project' : 'Which project?'}>
        <div style={{ maxWidth: 460 }}>
          <Field label="Project" required>
            <Lookup
              entity="project"
              value={projectId}
              label={label}
              onChange={(id, option) => {
                setLabel(option?.label ?? '')
                navigate(paths.drive(companyId, id ? { project: id } : {}))
              }}
              placeholder="Search by project number or name"
            />
          </Field>
        </div>
      </Panel>

      <ProjectDrivePage companyId={companyId} projectId={projectId} projectName={label} />
    </div>
  )
}
